export default __webpack_public_path__ + "static/Obol_Chris-Battenfield_Product-Lead-e63e4631b611fb701a4e5917c05d9855.jpg";